<body style="background-color: rgb(241, 235, 228);">
  <ngx-spinner size="large" bdColor="rgba(93, 32, 65, 0.75)"></ngx-spinner>
  <div class="row pagerow">
    <div class="col-sm-8" style="margin-top: 30px;">
      <div class="container" *ngIf="!undefined">
        <div class="row" style="border-bottom: 1px solid #efefef; width:90%; margin: 0 auto">
          <div class="eventtitle">{{eventDetails.event_name}}</div>
          <mat-divider></mat-divider>
        </div>
        <div style="margin-top: 10px;" class="row no-gutters">

          <div class="col-sm">

            <div class="imagecontainer">
              <img class="eventimage" src="{{'https://events.globalistic.tech/'+ eventDetails.images[0].filename}}"
                alt="">
              <share-buttons theme="modern-light" [include]="['facebook','whatsapp','copy']" [show]="3"
                [url]="eventDetails.link" [autoSetMeta]="false" [showText]="true" [size]="-2">
              </share-buttons>
            </div>

            <hr width="80%" style="margin-top: 10px;">
            <div class="map">
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fa fa-map-marker"></i></span><label
                    class="location">{{eventDetails.location}}</label>
                  <!-- <div (click)="showHideMap()" id="maptoggle" class="maptoggle">[Show Map]</div> -->
                </li>
              </ul>
              <div *ngIf="eventDetails.location_lat != null && eventDetails.location_lng != null" id="mapcontainer">
                <agm-map [latitude]="eventDetails.location_lat" [longitude]="eventDetails.location_lng" [zoom]="12">
                  <agm-marker [latitude]="eventDetails.location_lat" [longitude]="eventDetails.location_lng"
                    [markerDraggable]="false"></agm-marker>
                </agm-map>
              </div> 

            </div>
          </div>
          <div style="margin-left: 10px;" class="col-sm">
            <div class="header">
              <div *ngIf="!passedEvent && loggedIn" class="addtocalendar" ngbDropdown role="group">
                <button mat-raised-button class="addtocalendarbutton"><i class="fa fa-calendar-plus-o"></i>Add to
                  Calendar</button>
                <div class="dropdown-menu" ngbDropdownMenu>
                  <mat-checkbox color="primary" [checked]="isCheckedAndDisabled(item)" ngbDropdownItem
                    *ngFor="let item of eventDetails.event_dates" (click)="book(item.id)">
                    {{item.date | date: 'MMM dd,yyyy'}}
                  </mat-checkbox>
                </div>
              </div>

              <div *ngIf="!passedEvent && !loggedIn" class="addtocalendar" role="group">
                <button (click)="login()" mat-raised-button class="addtocalendarbutton"><i class="fa fa-calendar-plus-o"></i>Add to
                  Calendar</button>
              </div>

              <i (click)="goToCalendar()" class="fa fa-calendar viewcalendar"></i>
              <ul class="categorylist fa-ul">
                <li>
                  <span *ngIf="passedEvent"><i class="fa fa-clock-o"></i>This event has passed</span>
                  <span *ngIf="!passedEvent"><i class="fa fa-clock-o"></i><span>{{firstDate | date: 'MMM dd,yyyy'}} -
                      {{lastDate | date: 'MMM dd,yyyy'}} from {{eventDetails.event_dates[0].start_time }} until
                      {{eventDetails.event_dates[0].end_time}}</span></span>
                </li>
                <li>
                  <span *ngIf="website"><i class="fa fa-link"></i>{{eventDetails.website}}</span>
                </li>
                <li>
                  <span *ngIf="categoriesTrue"><i class="fa fa-tag"></i>{{categories}}</span>
                </li>
              </ul>
            </div>
            <div class="col-sm">
              <div (copy)="onCopy($event)" [innerHTML]="eventDetails.description"
                [ngClass]="{ 'isCollapsed': !isCollapsed &&isReadMore , 'collapsed': isCollapsed&&isReadMore }"
                style="margin-left: 10px;">
              </div>
              <span [hidden]="!isReadMore">
                <span (click)="isCollapsed = !isCollapsed" class="readmore" style="float: right;"
                  *ngIf="isCollapsed"><i>Read More...</i></span>
                <span (click)="isCollapsed = !isCollapsed" class="readmore" *ngIf="!isCollapsed"><i>Read Less</i></span>
              </span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div *ngIf="true" class="col-sm-4">

      <div class="column">
        <!-- Admin Advertisement Card-->
        <div style="font-weight: bold; margin-top:30px">Advertisement</div>
        <div (click)="navigate(adminAd.url)" class="sidecard ad">
          <img class="cardimg" src="{{'https://events.globalistic.tech/'+ adminAd.image}}" />
          <div class="sidecard-content ">
            <div class="title">{{adminAd.name}}</div>
            <div class="sub_title">{{adminAd.description}}</div>
            <div class="description">{{adminAd.url}}</div>
          </div>
        </div>
      

        <!-- User Advertisement Card-->
        <div (click)="navigate(userAd.link)" class="sidecard ad">
          <img class="cardimg" src="{{'https://events.globalistic.tech/'+ userAd.image}}" />
          <div class="sidecard-content ">
            <div class="title">{{userAd.name}}</div>
            <div class="sub_title">{{userAd.description}}</div>
            <div class="description">{{userAd.link}}</div>
          </div>
        </div>

      </div>

      <div class="column">
        <div style="font-weight: bold; margin-top:30px">Related Events</div>
        <!-- Related Events Card-->
        <div class="sidecard" *ngFor="let item of allEvents">
          <img class="cardimg" (click)="goToEventPage(item.events)"
            src="{{'https://events.globalistic.tech/'+ item.events.images[0].filename}}" />
          <div class="sidecard-content">
            <div matTooltip="{{item.events.event_name}}" class="title">
              {{item.events.event_name}}</div>
            <p class="description">{{item.events.organizer_name}}</p>
            <div class="sidecard-meta">
              <span matTooltip="{{item.events.location}}" class="details">
                <i style="margin-right: 3px;" class="fa fa-location-arrow"></i> {{item.events.location}}
              </span>
              <span class="details">
                <i style="margin-right: 3px;" class="fa fa-clock-o"></i>
                {{item.events.event_dates[0].date | date: 'MMM dd,yyyy'}}
              </span>
              <share-buttons theme="modern-light" [include]="['facebook','whatsapp','copy']" [show]="3"
               [autoSetMeta]="false" [showText]="false" [size]="-4"></share-buttons>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
